import { createRouteRef } from '@backstage/core-plugin-api';

export const accountmapRouteRef = createRouteRef({
  id: 'accountmap',
});

export const pendingAccountRouteRef = createRouteRef({
  id: 'pending-account-detail',
  params: ['id'],
});
